<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  async created() {
    document.title = '运营工具';
  }
}
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  background: #ffffff;
  /* background: #f0f0f0; */
  overflow: hidden;
}

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: "Lucida Console", Monaco, monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* margin-top: 60px; */
  width: 100%;
  height: 100%;
}

</style>
